import { call, put, select, takeLatest } from 'redux-saga/effects'
import { DocumentScannerConstants } from '../store/documentScanner.constants'
import { IDocumentAttachment, IDocumentScannerState } from '../store/documentScanner.types'
import { getDocumentScannerSelector } from '../selectors/documentScanner.selector'
import { setDocumentAttachments } from '../store/documentScanner.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IAttachment, IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getDateTime } from '../../../utilities'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* importDocuments() {
  const { scannedDocuments, documentAttachments }: IDocumentScannerState = yield select(getDocumentScannerSelector)

  const serviceId: string = yield select(getServiceIdSelector)
  const pcrId: string = yield select(getPcrIdSelector)
  if (!pcrId) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrID: string = yield select(getPcrIdSelector)

    if (pcrID) {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

      let index = 0
      pcrDoc._scannedDocumentAttachments?.forEach((attachment) => {
        if (attachment.index && attachment.index > index) index = attachment.index
      })
      index = index + 1

      const newDocumentAttachments = scannedDocuments.map((scannedDocument) => {
        const documentName = scannedDocument.name ? `${scannedDocument.name}.jpeg` : `Document${index}.jpeg`

        const newDocumentAttachment: IDocumentAttachment = {
          id: scannedDocument.id,
          imageSource: scannedDocument.imageSource,
          name: documentName,
          category: scannedDocument.category,
          index: scannedDocument.name ? undefined : index,
        }

        if (!scannedDocument.name) {
          index = index + 1
        }

        return newDocumentAttachment
      })

      const documentAttachmentsForPcr: IAttachment[] = newDocumentAttachments.map((documentAttachment) => {
        return {
          fileExtension: 'jpeg',
          data: documentAttachment.imageSource,
          category: documentAttachment.category,
          name: documentAttachment.name,
          id: documentAttachment.id,
          uploadedDt: getDateTime(),
          index: documentAttachment.index,
        }
      })

      const pcrDocUpdated: IPcr = {
        ...pcrDoc,
        _scannedDocumentAttachments: [...(pcrDoc._scannedDocumentAttachments || []), ...documentAttachmentsForPcr],
      }

      try {
        yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
        yield put(setDocumentAttachments([...documentAttachments, ...newDocumentAttachments]))
      } catch (e) {
        yield put(throwPcrException(`importDocuments() error: ${e}`))
      }
    }
  } catch (e) {
    yield put(throwPcrException(`importDocuments() error: ${e}`))
  }
}

export function* importDocumentsSaga() {
  yield takeLatest([DocumentScannerConstants.IMPORT_DOCUMENTS], performWithMutexHOG, importDocuments)
}
